import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';

import type { ExtendedSeriesOptionsType } from '@/components/Chart/types/highcharts';
import { Z_INDEX } from '@/constants/z-index';
import { chartTableCells } from '@/features/Factsheet/components/FactsheetView/FactsheetWindow/FactsheetBody/Tabs/ChartTab/chartTableCells';

import LegendItem from './LegendItem';

interface ChartLegendProps {
  series: ExtendedSeriesOptionsType[] | undefined;
}

const ChartLegend = ({ series }: ChartLegendProps) => (
  <Box sx={{ pt: 1, pb: 2 }}>
    <TableContainer
      component={Paper}
      sx={{ overflow: 'hidden', width: '100%' }}
    >
      <Table
        aria-label='chart legend table'
        size='small'
        sx={{
          thead: {
            top: 0,
            zIndex: Z_INDEX.chartOverlay
          }
        }}
      >
        <TableHead>
          <TableRow sx={{ '.MuiTableCell-head': { backgroundColor: 'gx.tileDark' } }}>
            {chartTableCells.map((cell, index) => (
              <TableCell
                key={cell.name}
                align={cell.align}
                sx={{ pr: chartTableCells.length - 1 === index ? 0 : 5 }}
              >
                <Typography
                  sx={theme => ({ color: theme.palette.gx.textDisabled })}
                  variant='body2'
                >
                  {cell.name}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody sx={{ maxHeight: 150 }}>
          {series?.map(item => (
            <LegendItem
              key={item.id}
              series={item}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
);

export default ChartLegend;
